export const theadLanguage = ["#", "Language", "Language Code", 'Language Type', "Actions"]
export const tbodyLang = [
    {
        sn: 1,
        language: 'English',
        langCode: 'eng'
    },
    {
        sn: 2,
        language: 'French',
        langCode: 'frn'
    }
]

export const theadBlogCategory = ["#", "Blog Category", "Language", "Actions"]
export const tbodyBlogCategory = [
    {
        sn: 1,
        BlogCategory: 'Travel',
        language: 'English'
    },
    {
        sn: 1,
        BlogCategory: 'Adventure',
        language: 'English'
    },

]

export const ModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
}